import MicrosoftClarity from './MicrosoftClarity'

const Metrics = () => (
  <>
    <MicrosoftClarity />
  </>
)

export default Metrics
